module.exports = __webpack_public_path__ + "6f5dcf6e540e1b00acb385b51580b665.svg";